// extracted by mini-css-extract-plugin
export default {"liveChatSessionInfoBubble":"LiveChatSessionInfoBubble-module__liveChatSessionInfoBubble--__BY8"};